function MasterclassesWorkshops() {
    return (
        <div>
            <h2>Masterclasses/Workshops</h2>
            <p>To compliment conference program IETBHEC’27 program committee is offering interactive Masterclasses workshops. The intended workshops should fall within the scope of IETBHEC'27 and should be of 2 hours duration. Academics, researchers and practitioners wishing to organise interactive workshops should submit workshop proposal/s using our submission link from IETBHEC’27 Website. </p>
            {/* <div className="px-5">
                <ul>
                    <li>Masterclass/Workshop Title</li>
                    <li>Duration (2 hours suggested)</li>
                    <li>A Technical Description of the Masterclass Topic Area</li>
                    <li>A Brief Statement of the relevance of the Proposed Masterclass</li>
                </ul>
            </div> */}
        </div>
    )
}

export default MasterclassesWorkshops